import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
  selector: 'umkt-back-button',
  standalone: true,
  imports: [CommonModule, MatIconModule, I18nPipe],
  templateUrl: './back-button.component.html',
  styleUrl: './back-button.component.scss'
})
export class BackButtonComponent {
  @Input() backAction?: () => void;

  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    if (this.backAction) {
      this.backAction();
    } else {
      window.history.back();
    }
    this.clicked.emit();
  }
}
